function PageNotFound() {
  return (
    <div className="h-screen w-screen justify-center items-center grid">
      <div className="text-center font-bold">
        <h1>Página Não Encontrada : (</h1>
        <h1>404</h1>
        <h3 className="text-blue-500">
          <a href="/">Clique aqui para voltar à página inicial</a>
        </h3>
      </div>
    </div>
  );
}

export default PageNotFound;
